export function ensureHttps(url: string | undefined): string {
  // Check if the string starts with "http://" or "https://"
  if (!url?.startsWith("http://") && !url?.startsWith("https://")) {
    // If not, add "https://" to the beginning of the string
    url = "https://" + url
  }

  return url
}
